// Centralized brand assets and constants for A Homely Abode

export const BRAND = {
  name: "A Homely Abode",
  founder: "Kiap Yong",
  positioning: "Trusted Real Estate Consultant & Marketer",
  whatsapp: "https://wa.me/6581005654",
  whatsappLabel: "WhatsApp Kiap Yong",
  phoneDisplay: "+65 8100 5654",
  email: "hello@ahomelyabode.com",
  valuationLink: "https://propertyportal.era.com.sg/evalue?refer=81005654",
};

export const ASSETS = {
  // Updated black logo provided by user
  logoBlack:
    "https://customer-assets.emergentagent.com/job_abode-agent-staging/artifacts/vcd5ayae_3-black-logo.png",
  logoWhite:
    "https://customer-assets.emergentagent.com/job_95524d20-12e1-4207-a7a6-2c3fb5bf3b6f/artifacts/4fj15buu_4-white-logo.png",
  portraits: {
    hero: "https://customer-assets.emergentagent.com/job_95524d20-12e1-4207-a7a6-2c3fb5bf3b6f/artifacts/s2r6517y_IMG_0579.JPG",
    about:
      "https://customer-assets.emergentagent.com/job_95524d20-12e1-4207-a7a6-2c3fb5bf3b6f/artifacts/i74ywsoi_IMG_0587.JPG",
    formal:
      "https://customer-assets.emergentagent.com/job_abode-agent-staging/artifacts/no4t22cu_IMG_0579.JPG",
  },
  lifestyle: {
    livingRoom:
      "https://images.pexels.com/photos/28853362/pexels-photo-28853362.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bronzeTexture:
      "https://images.pexels.com/photos/7605538/pexels-photo-7605538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    handshake:
      "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxyZWFsJTIwZXN0YXRlJTIwbWVldGluZyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3ODAwNTE3NDR8MA&ixlib=rb-4.1.0&q=85",
    agreement:
      "https://images.pexels.com/photos/8470844/pexels-photo-8470844.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
};

export const SOCIALS = {
  youtube: "https://www.youtube.com/@A_Homely_Abode",
  linktree: "https://linktr.ee/kiap_a.homely.abode",
  instagram: "https://www.instagram.com/a.homely.abode",
  facebook: "https://www.facebook.com/profile.php?id=100082055257830",
  tiktok: "https://www.tiktok.com/@a.homely.abode",
  whatsapp: "https://wa.me/6581005654",
};

/**
 * Navigation structure.
 * Parents with `children` are NOT directly clickable links — they only open dropdowns.
 */
export const NAV_LINKS = [
  { label: "Home", to: "/" },
  {
    label: "Why Me",
    key: "why-me",
    children: [
      { label: "About Me", to: "/why-me/about-me", desc: "Story, philosophy, approach" },
      { label: "Services", to: "/why-me/services", desc: "Consulting & marketing" },
    ],
  },
  { label: "Framework", to: "/framework" },
  {
    label: "Endorsements",
    key: "endorsements",
    children: [
      { label: "Testimonials", to: "/success-stories/testimonials", desc: "In their own words" },
      { label: "Proven Results", to: "/success-stories/proven-results", desc: "Case studies & outcomes" },
      { label: "Awards", to: "/success-stories/awards", desc: "Recognition & milestones" },
    ],
  },
  {
    label: "Resources",
    key: "resources",
    children: [
      { label: "Listings", to: "/listings", desc: "Curated active listings" },
      { label: "Property Valuation", to: "/resources/property-valuation", desc: "Know what your home is worth" },
      { label: "Calculators", to: "/resources/calculators", desc: "3 quick estimators" },
    ],
  },
  { label: "Blogs", to: "/resources/blogs" },
  { label: "Contact", to: "/contact" },
];
